import React from "react";
import {
  FaCheckCircle,
  FaTools,
  FaHandsHelping,
  FaLightbulb,
} from "react-icons/fa";

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="feature-style-one hover-active-item">
      <div className="content d-flex flex-column items-center">
        <div className="icon">
          <Icon size={40} />
        </div>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
      <img
        src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
        alt="shape"
      />
    </div>
  );
}

function BenefitsOFEthereum() {
  const features = [
    {
      title: "Proven, Reliable Platform",
      description:
        "Ethereum’s established platform provides the security, scalability, and innovation necessary for developing robust blockchain applications.",
      icon: FaCheckCircle,
    },
    {
      title: "Developer Support",
      description:
        "With access to the Ethereum developer community and extensive libraries, our experts bring advanced tools to expedite your project.",
      icon: FaTools,
    },
    {
      title: "End-to-End Support",
      description:
        "Xeer Technology guides your project from concept to completion, including ongoing support for maintenance and updates.",
      icon: FaHandsHelping,
    },
    {
      title: "Innovation Driven Solutions",
      description:
        "We leverage Ethereum’s latest advancements to ensure your project remains competitive and adaptable in the fast-evolving blockchain space.",
      icon: FaLightbulb,
    },
  ];

  return (
    <div
      className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="site-heading">
              <h4 className="sub-title">Our Features</h4>
              <h2 className="title split-text-right split-text-in-right split-lines">
                Benefits of Ethereum Development with Xeer Technology
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="fade-up-anim">
          <div className="row">
            <div className="col-xl-12">
              <div className="feature-style-one-items">
                {features.map((feature, idx) => (
                  <FeatureCard key={idx} {...feature} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BenefitsOFEthereum;
